import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  topContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: '1rem',
    borderRadius: '0.75rem',
    border: '1px solid #DCDFE1',
    padding: '1.5rem',
  },

  actionContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },

  skillContainer: {
    whiteSpace: 'normal',
    gap: '0.2rem',
    width: '100%',
    margin: '-0.25rem',
  },

  boxContainer: {
    display: 'inline-block',
    border: '1px solid #DCDFE1',
    borderRadius: '0.5rem',
    padding: '0.4rem',
    width: 'auto',
    cursor: 'pointer',
    margin: '0.2rem',
  },
}));

export default useStyles;
